<template>
  <div class="contract-scope-of-work flex flex-col justify-between w-full py-2">
    <template v-if="$mq === 'sm'">
      <scope-of-work-cell
        class="md:hidden"
        :scope="scope"
        :key="`${scope.category}-${index}`"
        v-for="(scope, index) in scopes"
        :category="scope.category"
        :location="scope.location"
        :type="scope.type"
        :design-sheets="scope.designSheets"
        :additional-services="scope.additionalServices"
        :change-orders="scope.changeOrders"
      />
    </template>
    <bdg-table-view :rows="scopes" :columns="columns">
      <template #beside-pagination>
        <bdg-button
          class="ghost has-icon w-full md:w-auto uppercase"
          before-icon-class="fal fa-plus-square"
          @click.native="addScopeOfWork"
        >
          add scope of work
        </bdg-button>
      </template>
    </bdg-table-view>
  </div>
</template>

<script>
import ScopeOfWorkCell from "../../elements/list-view/list-view-cells/contract-cells/ScopeOfWorkCell";
import BdgButton from "../../elements/BdgButton";
import BdgTableView from "../../elements/table-view/BdgTableView";
import IconTextCell from "../../elements/table-view/special-cells/IconTextCell";
import ScopeItemsCell from "../../elements/table-view/special-cells/ScopeItemsCell";
import ScopeOfWorkForm from "./forms/ScopeOfWorkForm";
import { ScopeDocumentTypeIcons } from "../../js-data/icon-maps";
import GenericDeleteModal from "../../components/modals/GenericDeleteModal";

export default {
  name: "ContractScopeOfWork",
  components: { BdgTableView, BdgButton, ScopeOfWorkCell },
  data() {
    return {
      contractId: parseInt(this.$route.params.id, 10),
      columns: [
        { label: "title", property: "name" },
        { label: "created on", property: "createdDate" },
        {
          label: "scope document type",
          property: "typeWithIcon",
          cellComponent: IconTextCell
        },
        { label: "location", property: "location" },
        { label: "type", property: "project_type" },
        {
          label: "scope items",
          property: "scopeItems",
          cellComponent: ScopeItemsCell
        },
        {
          label: "actions",
          property: "actions",
          actions: [
            {
              label: "edit",
              clickAction: scope => {
                this.$store.commit("setCreateEditComponentParams", {
                  createEditComponent: ScopeOfWorkForm,
                  createEditComponentData: scope,
                  createEditComponentIsShown: true
                });
              }
            },
            {
              label: "delete",
              clickAction: scope => {
                this.$store.commit("setConfirmationModalParams", {
                  type: "delete",
                  headerText: "Delete Confirmation",
                  bodyComponent: GenericDeleteModal,
                  bodyComponentData: {
                    entityName: "scope of work",
                    deleteFunction: () =>
                      this.$store.dispatch("deleteScope", scope)
                  },
                  isShown: true
                });
              }
            }
          ],
          additionalCellClasses: "w-px whitespace-no-wrap"
        }
      ]
    };
  },
  computed: {
    scopes() {
      const scopes = this.$store.state.Contracts.ScopeOfWork.scopes;
      if (scopes) {
        return scopes.map(scope => {
          scope.typeWithIcon = {
            iconClasses: ScopeDocumentTypeIcons[scope.type],
            text: scope.type.toUpperCase().replace("_", " ")
          };

          scope.scopeItems = {
            scopeItems: scope.scope_items
              ? scope.scope_items
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(i => i.name)
              : null,
            changeOrders: scope.change_orders
              ? scope.change_orders
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(i => i.name)
              : null,
            designSheets: scope.design_sheets
              ? scope.design_sheets
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(i => i.name)
              : null,
            additionalServices: scope.additional_services
              ? scope.additional_services
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(i => i.name)
              : null
          };
          return scope;
        });
      }

      return scopes;
    }
  },
  created() {
    this.$store.dispatch("getScopes", this.contractId);
  },
  methods: {
    addScopeOfWork() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: ScopeOfWorkForm,
        createEditComponentIsShown: true
      });
    }
  }
};
</script>

<style scoped></style>
